export default class TutorialAssets {

    private images: Map<string, {isLoaded: boolean, element: HTMLImageElement, promise: Promise<HTMLImageElement|null>}> = new Map();

    loadImageAsset(src: string): Promise<HTMLImageElement|null> {
        let existingImage = this.images.get(src);
        if (existingImage) {
            return existingImage.promise.then(() => this.getImageAsset(src));
        }

        let img = document.createElement("img");
        img.src = src;
        let promise = new Promise<HTMLImageElement|null>((res) => {
            img.onload = () => {
                let image = this.images.get(src);
                if (image != null) {
                    image.isLoaded = true;
                    res(this.getImageAsset(src));
                }
            };

            img.onerror = () => {
                console.log("Warn: error loading image " + img.src);
                res(null);
            };
        });

        this.images.set(src, {
            isLoaded: false,
            element: img,
            promise: promise
        });

        return promise;
    }

    getImageAsset(src: string): HTMLImageElement {
        let image = this.images.get(src);
        if (image == null)
            throw "Image not loaded [" + src + "]";

        let imageCopy = document.createElement("img");
        imageCopy.src = image.element.src;
        return imageCopy;
    }
}